import apiClient from "./apiClient";

export const initConnection = async (params: {
  provider: "SALESFORCE" | "HUBSPOT" | "STRIPE" | "QONTO";
  code: string;
  codeVerifier?: string;
  state?: string;
}) => {
  const response = await apiClient.post(
    `connections/${params.provider.toLowerCase()}/init`,
    params,
  );
  return response.data;
};

export const fetchData = async (provider: string) => {
  const response = await apiClient.get(
    `/connections/${provider.toLowerCase()}/data`,
  );
  return response.data;
};
